import { createSelector } from 'reselect';

const selectCache = (state: any) => state.referralChannels;

export const selectActiveChannel = createSelector(
  selectCache,
  (cache) => cache.activeChannel
);
export const selectActiveChannelLoading = createSelector(
  selectCache,
  (cache) => cache.acLoading
);

export const selectPausedReferralsCount = createSelector(
  selectCache,
  (cache) => cache.pausedReferralsCount
);

export const selectDraftChannels = createSelector(
  selectCache,
  (cache) => cache.draftChannel
);

export const selectActiveChannelsPageInfo = createSelector(
  selectCache,
  (cache) => cache.paginationInfo
);

export const selectChannelsLoading = createSelector(
  selectCache,
  (cache) => cache.loading
);

export const selectGmlLoading = createSelector(
  selectCache,
  (cache) => cache.gmlLoading
);

export const selectGmlProjectionItems = createSelector(
  selectCache,
  (cache) => cache.gmlProjectionItems
);

export const selectChannelErrors = createSelector(
  selectCache,
  (cache) => cache.error
);
